<div *ngIf="heading" class="heading">
  <mat-icon [svgIcon]="getIconName()"></mat-icon>
  {{ heading }}
</div>
<div class="content">
  <div class="message-container">
    <div id="alertBanner-text-message" *ngIf="message" class="message">{{ message }}</div>
    <div id="alertBanner-text-subtext" *ngIf="subtext" class="subtext">{{ subtext }}</div>
  </div>

  <div>
    <afp-button id="alertBanner-button-{{secondaryActionText | camelCase }}" *ngIf="secondaryActionText" [disabled]="isPrimaryActionDisabled" (click)="onSecondaryAction.emit()">
      {{ secondaryActionText }}
    </afp-button>
    <afp-button id="alertBanner-button-{{primaryActionText | camelCase }}" *ngIf="primaryActionText" variant="primary" [disabled]="isSecondaryActionDisabled" (click)="onPrimaryAction.emit()">
      {{ primaryActionText }}
    </afp-button>
  </div>
</div>
